'use client';
import type { RumInitConfiguration } from '@datadog/browser-rum';
import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin } from '@datadog/browser-rum-nextjs';

let initialized = false;

export const datadogRumAdapter: (config: RumInitConfiguration) => void = (
  config,
) => {
  if (initialized) return;

  datadogRum.init({
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask',
    trackResources: true,
    trackUserInteractions: false,
    trackLongTasks: true,
    ...config,
    plugins: [nextjsPlugin()],
  });

  initialized = true;
};
